module.exports = __webpack_public_path__ + "img/box_bg5.6bfc509.png";